var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C7 5.44772 7.44772 5 8 5L19 5C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7L9 7L9 25L19 25C19.5523 25 20 25.4477 20 26C20 26.5523 19.5523 27 19 27L8 27C7.73478 27 7.48043 26.8946 7.29289 26.7071C7.10536 26.5196 7 26.2652 7 26L7 6ZM17.1247 10.7191C17.5559 11.0641 17.6258 11.6934 17.2808 12.1247L14.9806 15H19.126C22.4397 15 25.126 17.6863 25.126 21C25.126 21.5523 24.6783 22 24.126 22C23.5737 22 23.126 21.5523 23.126 21C23.126 18.7909 21.3351 17 19.126 17H14.9807L17.2809 19.8753C17.6259 20.3066 17.556 20.9359 17.1247 21.2809C16.6935 21.6259 16.0642 21.556 15.7192 21.1247L12.1191 16.6247C11.827 16.2595 11.827 15.7405 12.1191 15.3753L15.7191 10.8753C16.0641 10.444 16.6934 10.3741 17.1247 10.7191Z",
    fill: "currentColor"
  })));
};
export default SvgExit;